import { BASE_V2_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  PATCH: 'CURRICULUM_BULK_UPDATE_PATCH',
  PATCH_SUCCESS: 'CURRICULUM_BULK_UPDATE_PATCH_SUCCESS',
  PATCH_FAILURE: 'CURRICULUM_BULK_UPDATE_PATCH_FAILURE',
};

export const patch = actions.patch(() => `${BASE_V2_URL}/practice-sheets/`, {
  PENDING: ACTIONS.PATCH,
  SUCCESS: ACTIONS.PATCH_SUCCESS,
  FAILURE: ACTIONS.PATCH_FAILURE,
});
